<template>
    <div class="EnergyConsump">
        <div class="EnergyConsump-body">
            <div class="ec-title">能耗监测</div>
            <div class="list">
                <div class="item">
                    <img class="img" src="@/assets/images/ljzdn.png" alt="">
                    <div class="item-title">
                        <div class="name">累计总电能：</div>
                        <div class="value">{{ energyData.totalEnergy || 0 }} KW·h</div>
                    </div>
                </div>
                <div class="item">
                    <img class="img" src="@/assets/images/zgl.png" alt="">
                    <div class="item-title">
                        <div class="name">总功率：</div>
                        <div class="value">{{ energyData.totalPower || 0 }} KW</div>
                    </div>
                </div>
                <div class="item">
                    <img class="img" src="@/assets/images/itzgl.png" alt="">
                    <div class="item-title">
                        <div class="name">IT总功率：</div>
                        <div class="value">{{ energyData.itPower || 0 }} KW</div>
                    </div>
                </div>
                <div class="item">
                    <img class="img" src="@/assets/images/itczl.png" alt="">
                    <div class="item-title">
                        <div class="name">IT负载率：</div>
                        <div class="value">{{ energyData.itLoadRate || 0 }} %</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import { getEnergyMonitoring } from "@/network/ems-record.js"

export default {
    name: "EnergyConsump",
    data() {
        return {
            energyData: {
                totalEnergy: 0,    // 累计总电能
                totalPower: 0,     // 总功率
                itPower: 0,        // IT总功率
                itLoadRate: 0      // IT负载率
            },
            timer: null
        }
    },
    created() {
        this.getData();
        // 添加到全局定时器管理
        this.$store.dispatch('addIntervalObj', {'getEnergyData:60000': this.getData})
    },
    destroyed() {
        // 组件销毁时清除定时器
        this.$store.dispatch('removeIntervalObj', 'getEnergyData')
    },
    methods: {
        getData() {
            getEnergyMonitoring().then(res => {
                if (res.code === 0 && res.data) {
                    // 保留两位小数
                    this.energyData = {
                        totalEnergy: Number(res.data.energy).toFixed(2),
                        totalPower: Number(res.data.totalPower).toFixed(2),
                        itPower: Number(res.data.itPower).toFixed(2),
                        itLoadRate: Number(res.data.itLoadRate).toFixed(2)
                    }
                }
            }).catch(err => {
                console.error('获取能耗数据失败:', err);
            })
        }
    }
}
</script>

<style scoped>
.EnergyConsump {
    width: 100%;
    height: 100%;
}

.EnergyConsump-body {
    width: 100%;
    height: 100%;
    padding: 5% 3% 5% 10%;
}

.EnergyConsump-body  .ec-title {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 1.1rem;
    color: #00E3F6;
    margin-bottom: 8%;
}

.EnergyConsump-body  .list {
    width: 100%;
    padding-left: 10px;
    height: calc(70%);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.EnergyConsump-body  .list .item {
    width: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 0.9rem;
}

.EnergyConsump-body  .item-title {
    display: flex;
    align-items: center;
}

.EnergyConsump-body  .img {
    width: 25px;
    margin-right: 15px;
}

.EnergyConsump-body  .name {
    height: 25px;
    font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
    color: #DADEE3;
    line-height: 25px;
}
.EnergyConsump-body  .value {
    font-size: 1.2rem;
    color: #FFFFFF;
    font-weight: 500;
}
</style>